export const SALES_TARGET = 'dashboard-sales-sum';
export const OFFERS_TARGET = 'dashboard-offers-count';
export const VISITS_TARGET = 'dashboard-visits-count';
export const TARGETS = [SALES_TARGET, OFFERS_TARGET, VISITS_TARGET];
export const TARGET_BUDGET = 'dashboard-sales-budget-sum';
